var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('router-link',{attrs:{"to":"/data-description","target":"_blank"}},[_vm._v("Data Description")]),_vm._v(" page")],1)}
var staticRenderFns = []

export { render, staticRenderFns }